import { Button, Icons, tokens, Typography, Stack } from '@cast/design-system';

type ServiceHealthCtaTileProps = {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  actionTestId?: string;
};

/** Full-width footer CTA / no-data copy under Cluster reliability tiles. */
export const ServiceHealthCtaTile = ({
  message,
  actionLabel,
  onAction,
  actionTestId,
}: ServiceHealthCtaTileProps) => (
  <Stack
    alignItems="center"
    gap={8}
    pt={8}
    sx={{ width: '100%', gridColumn: '1 / -1' }}
    data-testid="service-health-cta"
  >
    <Typography
      variant="P14M"
      color={tokens.theme.fg.structural.primary}
      data-testid="service-health-cta-message"
      sx={{ textAlign: 'center' }}
    >
      {message}
    </Typography>
    {actionLabel && onAction ? (
      <Button
        variant="text"
        size="md"
        testId={actionTestId}
        onClick={() => onAction()}
        endIcon={<Icons.ArrowRight size={20} />}
        sx={{
          px: 0,
          py: '2px',
          minWidth: 0,
          color: tokens.theme.fg.action.primary,
          typography: 'P14M',
        }}
      >
        {actionLabel}
      </Button>
    ) : null}
  </Stack>
);

type ServiceHealthAgentCtaTileProps = {
  onInstallAgent: () => void;
};

export const ServiceHealthAgentCtaTile = ({
  onInstallAgent,
}: ServiceHealthAgentCtaTileProps) => (
  <ServiceHealthCtaTile
    message="Track 3 more reliability metrics like latency and error rate with the Cast AI agent"
    actionLabel="Install Cast AI agent"
    onAction={onInstallAgent}
    actionTestId="service-health-install-agent-button"
  />
);
